<!-- 巡课后台框架 -->
<template>
  <div class="FontContent">
    <template v-if="!maxrightTop">
      <Header></Header>
    </template>
    <div :class="{viewRoter: !maxrightTop ,viewRotermax: maxrightTop}">
      <template v-if="whitelist.indexOf($route.path) == -1">
        <NavMenu />
      </template>
      <div class="viewWeb">
        <!-- <keep-alive :include="['record']">
          <router-view />
        </keep-alive> -->
        <!-- 根据：组件名称缓存 -->
        <!--  onActivated : 组件在被激活时触发
              onDeactivated : 组件在跳转走被缓存时触发 -->
        <!-- <router-view v-slot="{Component}">
          <keep-alive :include="['record']">
            <component :is="Component"></component>
          </keep-alive>
        </router-view> -->
        <!-- 根据：路由配置缓存 -->
        <router-view v-slot="{Component}" v-if="menulist.length !== 0">
          <keep-alive>
            <component v-if="$route.meta.keepAlive" :key="$route.path" :is="Component"></component>
          </keep-alive>
          <component v-if="!$route.meta.keepAlive" :key="$route.path" :is="Component"></component>
        </router-view>
         <Empty
            v-if="menulist.length == 0"
            :imgRequire="require('@/assets/Frame113160.png')"
            height="90%"
            >暂无权限</Empty
          >
      </div>
    </div>

    <!-- DeepSeek接口都需要登录才能用————宋柏欣 -->
    <!-- <DeepSeek v-if="getToken" /> -->
  </div>
</template>

<script setup>
import {
  onMounted,
  onBeforeUnmount,
  getCurrentInstance,
  onUnmounted,
  ref
} from "vue";
const { $eventBus } = getCurrentInstance().appContext.config.globalProperties;
import { useRouter, useRoute } from "vue-router";
import Cookies from "js-cookie";
import Header from "@/components/header";
import NavMenu from "../components/menu";
import DeepSeek from "@/views/DeepSeek";
import Empty from "@/components/empty/empty";
import { getRoleMenuByUserId } from "@/api/Backs/rolePermission.js";
let privatization = window.g.privatization; /// 是否私有化部署， true/是 false/否
const menulist = ref([]);
const getToken = Cookies.get("tokenValue");
const userInfo = Cookies.get("userInfo");
const userId = JSON.parse(userInfo).userId;

import { getRoleButtonByUserId } from "@/api/base.js";
// 所有按钮权限ids
getRoleButtonByUserId(userId).then((res) => {
  if (res.code === 1) {
    let menuBtns =res.data?res.data: [];
  
    // 存储按钮权限
    localStorage.setItem("ButtonPermissionsXK", JSON.stringify(menuBtns));
  }
});

const whitelist = ['/SCADA/Detail'];// 进入详情页 隐藏左侧菜单 兼容keeplive缓存 打开的页面不在统一路由配置children组内 缓存会无效  隐藏左侧菜单来实现当前页面铺满

const router = useRouter();
const route = useRoute();
// 全屏
const maxrightTop = ref(false);
const toggleFullScreen = (data) => {
  const fullscreenElement = window.fullScreen || document.fullscreenElement;
  if (fullscreenElement) {
    maxrightTop.value = true;
  } else {
    maxrightTop.value = false;
  }
};
function keydown (event){
 if (event.keyCode === 122) {
    event.returnValue = false;
    toggleFullScreen(); //这里方的是触发全屏的方法
  }
}

let getRoleMen = () => {
  getRoleMenuByUserId(userId, '').then((res) => {
    if (res.code == 1) {
      menulist.value = res.data?res.data:[];
      // 显示暂无权限
    }else {
      menulist.value = [];
    }
  });
};

onMounted(() => {
  // 显示暂无权限
  getRoleMen();

  toggleFullScreen();
  document.addEventListener("fullscreenchange", toggleFullScreen, false);
  window.addEventListener("keydown", keydown, true); // 监听按键事件

  
});
onBeforeUnmount(() => {
  window.removeEventListener("keydown", keydown, false);
  window.removeEventListener("fullscreenchange", toggleFullScreen, false);
})
onUnmounted(() => {
});
</script>

<style lang="less" scoped>
.FontContent{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #EFF2F9;
  .viewRoter{
    padding: 10px;
    width: 100%;
    height: calc(100% - 56px);
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: 10px;
    .viewWeb{
      flex: 1;
      height: 100%;
      border-radius: 12px;
      background: #FFF;
      overflow: hidden;
      overflow-y: auto;
      box-shadow: 0px 0px 20px 0px rgba(0, 14, 138, 0.05);
    }
  }
  .viewRotermax{
    padding: 10px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: 10px;
    .viewWeb{
      flex: 1;
      height: 100%;
      border-radius: 12px;
      background: #FFF;
      overflow: hidden;
      overflow-y: auto;
      box-shadow: 0px 0px 20px 0px rgba(0, 14, 138, 0.05);
    }
  }
}
</style>
